import React, { useState } from 'react';
import './list-item.scss';

// Assets
import { ReactComponent as RemoveIcon } from '../../asset/remove.svg';

// Config
import { icons } from '../../config/status';

const ListItem = ({ item, onRemove, onClick, hasBadges }) => {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<div className="list-item" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
			<div className="list-item__status-icon">
				{onRemove && hasBadges && (
					<div
						className="list-item__status-icon-badge"
						style={{ visibility: item.putBadge ? 'visible' : 'hidden' }}
					>
						<span className="list-item__status-icon-badge-dot"></span>
					</div>
				)}
				{icons[`${item.status}${onRemove ? '' : '_blank'}`]}
			</div>
			<div className="list-item__text-container">
				<div
					className="list-item__info"
					style={{
						cursor: onRemove && isHovered ? 'pointer' : 'default'
					}}
					onClick={() => onClick && onClick(item)}
				>
					<p className="list-item__info__title">{item.title || item.code}</p>
					<p className="list-item__info__subtitle">{item.subtitle}</p>
				</div>
				<div className="list-item__right-holder">
					<div
						className="list-item__remove"
						onClick={() => (onRemove ? onRemove(item) : undefined)}
						style={{
							opacity: onRemove && isHovered ? 1 : 0,
							cursor: onRemove && isHovered ? 'pointer' : 'default'
						}}
					>
						<RemoveIcon />
					</div>
					{onRemove && item.title && (
						<p className="list-item__code" style={{ opacity: onRemove && isHovered ? 0.4 : 1 }}>
							{item.code}
						</p>
					)}
					<p className="list-item__date" style={{ opacity: onRemove && isHovered ? 0.3 : 0.55 }}>
						{item.date}
					</p>
				</div>
			</div>
		</div>
	);
};

export default ListItem;
